import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Tag from 'core/components/Tag';
const DeprecatedTag = props => /*#__PURE__*/React.createElement(Tag, _extends({
  intent: "warning",
  monospace: true,
  minimal: true
}, props), "DEPRECATED");
export default DeprecatedTag;